import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import StringCell from '@/backgrid/StringCell';

import OrderSummaryGridView from '../../../views/OrderSummaryGridView/OrderSummaryGridView';

import tmplMFDSummaryView from './MFDSummaryView.hbs';

import './MFDSummaryView.css';

const MFDSummaryView = View.extend({
  template: tmplMFDSummaryView,

  className: 'mfd-summary-view',

  ui: {
    monoSummaryTable: '.mono-summary-table',
    colorSummaryTable: '.color-summary-table'
  },

  regions: {
    monoSummaryTable: '@ui.monoSummaryTable',
    colorSummaryTable: '@ui.colorSummaryTable'
  },

  onRender() {
    this.monoColumns = [
      {
        name: 'monoItem',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 35,
        editable: false
      },
      {
        name: 'monoQuantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false
      }
    ];

    this.colorColumns = [
      {
        name: 'colorItem',
        label: 'Item',
        cell: StringCell,
        headerCell: 'custom',
        width: 35,
        editable: false
      },
      {
        name: 'colorQuantity',
        label: 'Quantity',
        cell: StringCell,
        headerCell: 'custom',
        width: 8,
        editable: false
      }
    ];

    this.monoCollection = new Backbone.Collection([
      {
        monoItem: 'Unclassified Monochrome (B&W) Devices (NIPR)',
        monoQuantity: this.model.get('order').totalMonoNIPRQuantity
      },
      {
        monoItem: 'Classified Monochrome (B&W) Devices (SIPR)',
        monoQuantity: this.model.get('order').totalMonoSIPRQuantity
      },
      {
        monoItem: 'Total Number of Monochrome (B&W) Devices',
        monoQuantity: this.model.get('order').totalMonoQuantity
      }
    ]);

    this.colorCollection = new Backbone.Collection([
      {
        colorItem: 'Unclassified Color Devices (NIPR)',
        colorQuantity: this.model.get('order').totalColorNIPRQuantity
      },
      {
        colorItem: 'Classified Color Devices (SIPR)',
        colorQuantity: this.model.get('order').totalColorSIPRQuantity
      },
      {
        colorItem: 'Total Number of Color Devices',
        colorQuantity: this.model.get('order').totalColorQuantity
      }
    ])

    this.monoSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.monoCollection,
      columns: this.monoColumns
    });

    this.colorSummaryGridView = new OrderSummaryGridView({
      model: this.model,
      collection: this.colorCollection,
      columns: this.colorColumns
    })

    this.showChildView('monoSummaryTable', this.monoSummaryGridView);
    this.showChildView('colorSummaryTable', this.colorSummaryGridView);
  }
});

export default MFDSummaryView;